export { default as MaterialSolidIcon } from './MaterialSolidIcon';
